import {
  BillableHoursProposalFormProps,
  BonusProposalFormProps,
  SalaryProposalFormProps,
} from './index';

export type { BonusProposalFormProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBonusProposalsLayout/useBonusProposalsLayout';
export type { SalaryProposalFormProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeSalaryProposalsLayout/useSalaryProposalsLayout';
export type { BillableHoursProposalFormProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBillableHoursProposalsLayout/useBillableHoursProposalsLayout';

export type ProposalFormProps =
  | SalaryProposalFormProps
  | BillableHoursProposalFormProps
  | BonusProposalFormProps;

export enum ProposalFormPropsMessageContext {
  NewProposal = 'newProposal',
}

export type ProposalFormPropsMessage = {
  context: ProposalFormPropsMessageContext;
  message: string;
};
